// extracted by mini-css-extract-plugin
export default {"container":"container-L1T_PHWu84COO9zb3ssN","picto":"picto-dub0dCy6IXt4PQ9Oj7JR"};